import React from 'react';
import ComingSoon from '../components/ComingSoon';

export default function BrokerIntegrations() {
  return (
    <ComingSoon
      eyebrow="FLOWQUANT PREMIUM"
      title="Broker Integrations"
      description="Connect supported brokers like Alpaca, Binance, and Robinhood to auto-import trades and reduce manual entry, making FlowQuant a more connected trading workspace."
    />
  );
}